// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"lp-z","imageAndVideoCount":"mp-z","imageAndVideoContainer":"np-z","viewAllReviews":"op-z"};